module.exports = __webpack_public_path__ + "static/media/video-august.02594bec.jpg";